"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auto = void 0;
var auto = {
  name: 'Auto',
  link: '',
  logo: 'Auto',
  colors: {
    active: 'fontNeutral90',
    font: 'fontNeutral60',
    background: 'backgroundNeutral10'
  },
  links: [{
    id: 'financiamento-de-carros',
    label: 'Financiamento de carros',
    link: '/financiamento-veiculos'
  }, {
    id: 'loja-de-carros',
    label: 'Loja de carros',
    link: '/carro/loja'
  }]
};
exports.auto = auto;